import styled from 'styled-components';
import { Stack } from 'components/Stack';
import CustomScrollbar from 'components/CustomScrollbar';

const AdditionalContainer = styled(CustomScrollbar)<{ isMobile: boolean }>`
  padding-left: 16px;
  padding-right: 8px;
  margin: 16px 0px;
  ${({ isMobile }) => !isMobile && 'max-height: 190px; overflow: auto;'};
`;

const AdditionalInformation = styled(Stack).attrs({ gap: 16 })``;

export { AdditionalContainer, AdditionalInformation };
